<template>
  <div style="background: #F4F4F4" id="home">
    <div style="background:#FAE00B" class="ht4"></div>
    <div class="tzSection">
      <div class="" @click="showNotice">
        <van-notice-bar left-icon="volume-o" :text="title" />
      </div>
    </div>
    <van-dialog v-model="show3" :title="title" :show-confirm-button="false">
      <div class="homenotice">
        <div v-html="sContent"></div>
      </div>
              <div class="fsac noticeBtn" style="height: 10vw; position: rela">
          <van-button type="info" size="mini" color="#FAE00B" @click="show3 = false">
            <div class="syBtnTxtBrss">确定
              <!-- <span v-show="cd">({{cd}})</span> -->
            </div>
          </van-button>
        </div>
    </van-dialog>
    <div class="ht4" style="background:#FAE00B"></div>
    <div class="homeUpSection">
      <div class="fs">
        <div class="homePanel1 ml15 qcard" @click="goto('sy')">
          <div class="m12">
            <div class="hpt1">我的收益</div>
            <div class="fssb mt14">
              <div>
                <div class="hl22">
                  <!-- <img src="../../assets/sy.png" class="hpi1"> -->
                  <span class="hpt2">累计收益(元)</span>
                </div>
                <div class="hpt3">
                  <span>{{baseInfo.dBonus | currency()}}</span>
                </div>
                <div class="hl22 mt6">
                  <!-- <img src="../../assets/sy.png" class="hpi1"> -->
                  <span class="hpt2">我的余额(元)</span>
                </div>
                <div class="hpt3">
                  <span>{{baseInfo.dBalance | currency()}}</span>
                </div>
              </div>
              <div>
                <div class="hl22">
                  <!-- <img src="../../assets/sy.png" class="hpi1"> -->
                  <span class="hpt2">今日收益(元)</span>
                </div>
                <div class="hpt3">
                  <span>{{countInfo.todayBonus | currency()}}</span>
                </div>
                <div class="hl22 mt6">
                  <!-- <img src="../../assets/sy.png" class="hpi1"> -->
                  <span class="hpt2">本月收益(元)</span>
                </div>
                <div class="hpt3">
                  <span>{{countInfo.monthBonus | currency()}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml10">
          <div class="homePanel2 fsb card-1" @click="goto('orderCount')">
            <div class="ml8">
              <div class="ht10"></div>
              <div class="hp2t1">
                我的任务
              </div>
              <div class="hp2t2">
                随时掌握
              </div>
            </div>
            <div class="mr8">
              <img src="../../assets/my_mission.png" class="hp2i">
            </div>
          </div>
          <div class="homePanel2 fsb mt10 card-1" @click="goto('rank')">
            <div class="ml8">
              <div class="ht10"></div>
              <div class="hp2t1">
                收益排行
              </div>
              <div class="hp2t2">
                TOP 10
              </div>
            </div>
            <div class="mr8">
              <img src="../../assets/top10.png" class="hp2i">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeMiddleSection"></div>
    <div class="homeBottomSection">
      <div class="fsb">
      <div class="sectionTitle">任务列表</div>
      <div class="sectionTitle"><van-icon name="location" />{{city}}</div>
      </div>
      <div class="homecard mb13 card-1" v-for="item in MissionList" :key="item.Id" @click="gotoP('missionDetail', item)">
        <div class="homecardIn">
          <div class="fs">
            <div class="fscc">
              <img :src="item.sLogo" class="Mlogo">
            </div>

            <div class="fssb" style="width: 100%">
              <div class="ml10">
                <div class="Mname">
                  {{item.sName}}
                </div>
                <div class="mt3">
                  <van-tag type="danger"><span class="tagTest">{{item.sCategoryName}}</span></van-tag>
                  <!-- <div class="CnameHome">
                    {{item.sCategoryName}}
                  </div> -->
                </div>
                <div class="mt3">
                   <div class="PnameHome">完成: {{item.iDoneNumber}}次</div>
                  <!-- <div class="PnameHome">
                    限时{{item.iOrderCycle}}小时完成
                  </div> -->
                </div>
              </div>
              <div>
                <div class="ht15"></div>
                <div class="dPricesHome">
                  {{item.dPrices | currency()}}<span class="dPricesUnit">元</span>
                </div>
                <div class="mt8">
                  <div class="Tname">
                    任务奖励
                  </div>
                              <!-- <van-button round type="info" size="mini" color="#FAE00B">
              <div class="syBtnTxtHome">立即前往</div>
            </van-button> -->
                </div>
              </div>
            </div>
          </div>
          <van-divider></van-divider>
          <div class="fssb syBtnHome mt10" style="fl">
            <div class="fsw">
            <div class="m2" v-if="item.iInternal">
               <van-tag type="success"><span class="tagTest" >内部</span></van-tag>
            </div>
            <div v-for="tag in item.tags" :key="tag"  class="m2">
               <van-tag color="#ffe1e1" text-color="#ad0000"><span class="tagTest" >{{tag}}</span></van-tag>
            </div>
            </div>
            <!-- <div class="PnameHome">剩余:{{item.iNumber}}次</div> -->
            <!-- <div class="PnameHome">完成:{{item.iDoneNumber}}次</div> -->
            <van-button round type="info" size="mini" color="#FAE00B">
              <div class="syBtnTxtHome">立即前往</div>
            </van-button>
          </div>
        </div>
      </div>
      <div class="ht15"></div>
      <van-tabbar v-model="active" @change="onChange" active-color="#111111" inactive-color="#999999" placeholder>
        <van-tabbar-item>
          <template #icon>
            <img src="../../assets/home_active.png">
          </template>
          首页
        </van-tabbar-item>
        <van-tabbar-item icon="setting-o">
          <template #icon>
            <img src="../../assets/my.png">
          </template>
          我的
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
  import { Toast, Button, Tag, Dialog, Tabbar, TabbarItem, NoticeBar, Icon, Divider } from 'vant';
  import axios from 'axios'
  import wxu from '@/utils/wxu'
  export default {
    created() {
      let token = window.sessionStorage.getItem('token')
      // console.log(window.location.href.split('?')[0])
      let s = window.location.href.includes('code')
      if (s) {
        window.location.href = window.location.href.split('?')[0] + '#/home'
      }
      axios.defaults.headers.common['Token'] = token
      this.iAuditStatus = Number(window.sessionStorage.getItem('iAuditStatus'))
      // this.getJsSdkConfig()
      if (this.iAuditStatus !== 0) {
        // this.getNotice()
        this.ClientGet()
        // this.CountInfoGet()
        // this.getBonusRecord()
      } 
      if (this.iAuditStatus === 2) {
        this.CountInfoGet()
        this.getNotice()
        this.getMissionList()
      } else {
        this.showConf()
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', this.goBack, false)
      }
      setTimeout(() => {
        if (!this.ad_info.city_code) {
          this.getJsSdkConfig()
        } else {
          this.city = this.ad_info.city
          // Toast.success(this.ad_info.city)
        }
      }, 300)
      // this.getJsSdkConfig()
      window.sessionStorage.setItem('oi', 0)
      // this.getMissionList()
    },
    destroyed() {
      window.removeEventListener('popstate', this.goBack, false)
    },
    components: {
      [Tag.name]: Tag,
      [Button.name]: Button,
      [Dialog.name]: Dialog,
      [Dialog.Component.name]: Dialog.Component,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [NoticeBar.name]: NoticeBar,
      [Icon.name]: Icon,
      [Divider.name]: Divider
    },
    computed: {
      p() {
        return this.$route.name
      },
      wxconfig() {
        return this.$store.state.wxconfig
      },
      initLink() {
        return this.$store.state.initLink
      },
      ad_info() {
        return this.$store.state.ad_info
      },
      mapKey() {
        return this.$store.state.mapKey
      }
    },
    data() {
      return {
        MissionList: [],
        page: 1,
        rows: 99,
        show3: false,
        active: 0,
        latitude: '',
        longitude: '',
        title: '',
        sContent: '',
        btnS: true,
        city: '',
        baseInfo: {

        },
        cd: 6,
        countInfo: {

        },
        s: 'ruok'
      }
    },
    methods: {
      finish() {
        this.btnS = false
      },
      showNotice () {
        if (this.iAuditStatus === 2) {
          this.show3 = true
        } else {
          Toast.fail('您的账号还未注册，或在审核中')
        }
      },
      async getJsSdkConfig() {
        let self = this
        let url = window.__wxjs_is_wkwebview ? window.location.href.split('#')[0] : window.location.href
        url = window.location.href.split('#')[0]
        // url = 'http://www.baidu.com'
        // url = 'http://zqb.sczhbf.com/'
        // console.log(url)
        // console.log(window.__wxjs_is_wkwebview)
        // let Toast = Toast
        wxu.init([
          'getLocation'
        ], url).then((wx, res) => {
          this.s = JSON.stringify(res)
          console.log(res, 99090909090)
          // 这里写微信的接口
          wx.getLocation({
            debug: false,
            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              self.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              self.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              self.accuracy = res.accuracy; // 位置精度
              self.rarp()
            },
          })
        }), function(err) {
          Toast.fail(err)
          console.log(111, err)
        }
      },
      rarp() {
        let self = this
        let resUrl = `http://apis.map.qq.com/ws/geocoder/v1`
        let params = {
          location: this.latitude + ',' + this.longitude,
          key: this.mapKey,
          get_poi: 0,
          // coord_type: 'gcj02',//输入的locations的坐标类型,1 GPS坐标
          output: 'jsonp',
        }
        this.$jsonp(resUrl, params)
          .then((res) => {
            let { ad_info, address } = res.result
            this.city = ad_info.city
            self.$store.dispatch('aLoc', { ad_info, address })
          }).catch((e) => {
            console.log(e)
          })
      },
      async getNotice() {
        // this.$refs['countDown'].reset()
        let Id = window.sessionStorage.getItem('newNotice')
        let { data, info, success } = await this.$api.getNewNotice()
        if (success) {
          this.title = data.sTitle
          window.sessionStorage.setItem('newNotice', data.Id)
          this.sContent = decodeURI(data.sContent)
          this.btnS = true
          if (Id === data.Id) {
            return
          }
          this.cd = 6,
          setInterval(() => {
            if (this.cd >= 1) {
              this.cd -=1
            }
          }, 1000)
          this.show3 = true
          // console.log(this.$refs)
          // // this.$refs['countDown'].start()
        } else {
          Toast.fail(info)
        }
      },
      showConf() {
        this.$router.push('submit')
        // Dialog.confirm({
        //     title: '注册',
        //     message: '您还未注册无法领取任务!',
        //     cancelButtonText: '先逛逛',
        //     confirmButtonText: '直接去注册'
        //   })
        //   .then(() => {
        //     // on confirm
        //     this.$router.push('submit')
        //   })
        //   .catch(() => {
        //     // on cancel
        //     window.close()
        //   })
      },
      async ClientGet() {
        let { data, info, success } = await this.$api.ClientGet()
        if (success) {
          this.baseInfo = data
          let bi = JSON.stringify(data)
          window.sessionStorage.setItem('bi', bi)
        } else {
          Toast.fail(info)
        }
      },
      async CountInfoGet() {
        let { data, info, success } = await this.$api.GetCountInfo()
        if (success) {
          console.log(data)
          this.countInfo = data
        } else {
          Toast.fail(info)
        }
      },
      async getMissionList() {
        let params = {
          page: this.page,
          rows: this.rows,
          sort: 'iSort desc,dInsertTime',
          order: 'desc'
        }
        let { data, success } = await this.$api.getMissonList(params)
        if (success) {
          this.MissionList = data.rows.map(item => {
            item.tags = item.sTag ? item.sTag.split(',') : []
            return item
          })
        }
      },
      goto(path) {
        console.log(path)
        this.$router.push(path)
      },
      gotoP(path, { Id, dPrices }) {
        this.$router.push({ path, query: { Id, dOrderPrices: dPrices } })
      },
      onChange(index) {
        if (index === 1) {
          this.goto('/my')
        }
      }
    }
  };
</script>

<style>
  .tzSection {
    padding: 15px;
    background: #FAE00B;
  }

  .tz {
    border-radius: 9px;
  }

  .homeUpSection {
    background: #FAE00B;
    height: auto;
    /* padding-bottom: 35px; */
  }

  .hpt1 {
    color: #F5D5BC;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
  }

  .hpi1 {
    width: 11px;
    height: 11px;
  }

  .hpt2 {
    color: rgba(245, 213, 188, 0.6);
    font-size: 14px;
    display: inline-block;
    margin-left: 0px;
  }

  .hpt3 {
    margin-top: 3px;
    font-size: 18px;
    letter-spacing: 1px;
    color: white;
    font-family: 'DC';
    font-weight: 600;
  }

  .homePanel1 {
    background: #2F2D2B;
    width: 230px;
    height: 150px;
    border-radius: 10px;
  }

  .homePanel2 {
    background: #fff;
    width: 107px;
    height: 70px;
    border-radius: 10px;
  }

  .hp2t1 {
    height: 28px;
    line-height: 28px;
    color: #333;
    font-size: 14px;
    text-shadow: 0px 0px 1px #333;
    /* font-weight: bold; */
  }

  .hp2t2 {
    /* margin-top: 1px; */
    text-align: center;
    color: #666;
    font-size: 12px;
  }

  .hp2i {
    margin-top: 20px;
    width: 28px;
    height: 28px;
  }

  .homeMiddleSection {
    height: 125px;
    width: 100%;
    background: linear-gradient(180deg, #FAE00B, #F4F4F4);
  }

  .homeBottomSection {
    /* background: #fbfbfb; */
    background: transparent;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    min-height: 400px;
    z-index: 1;
    margin-top: -120px;
    padding: 0 15px;
  }

  .p15 {
    padding: 0 15px;
  }

  .p10 {
    padding: 0 10px;
  }
  .homecard {
    width: 345px;
    /* height: 150px; */
    background: #FFFFFF;
    border: 1px white solid;
    /* box-shadow: 0px 3px 6px 0px rgba(34, 34, 34, 0.1); */
    border-radius: 16px;
  }

  .card-1 {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
    /* transition: all 0.3s cubic-bezier(.25,.8,.25,1)   */
  }

  .card-2 {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.08);
    /* transition: all 0.3s cubic-bezier(.25,.8,.25,1)   */
  }

  .homecardIn {
    margin: 10px 10px;
  }

  .Mlogo {
    width: 50px;
    height: 50px;
    border-radius: 6px;
  }

  .Mname {
    color: #444;
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: bold;
  }

  .CnameHome {
    background: #F53F46;
    color: white;
    /* letter-spacing: 1px; */
    font-size: 12px;
    /* text-align: center; */
    border-radius: 2px;
    padding: 0 5px;
    /* width: 62px; */
  }

  .PnameHome {
    /* text-align: center; */
    /* background: #e6e6e6; */
    color: #777;
    font-size: 12px;
    /* padding: 0 5px; */
    /* font-weight: bold; */
  }

  .dPricesHome {
    color: #F53F46;
    font-size: 18px;
    text-align: right;
    font-family: 'DC';
    font-weight: 600;
    letter-spacing: 1px;
  }

  .dPricesUnit {
    font-size: 12px !important;
    display: inline-block;
    font-weight: 400 !important;
    margin-left: 2px;
  }

  .Tname {
    color: #b0b0b0;
    letter-spacing: 1px;
    font-size: 10px
  }

  .syBtnHome {
    /* height: 64px; */
  }

  .syBtnTxtHome {
    color: black;
    width: 74px;
    letter-spacing: 1px;
    font-size: 12px
  }

  .tagTest {
    font-size: 11px;
    letter-spacing: 1px;
  }

  .homenotice {
    height: 400px;
    padding: 10px;
    overflow: auto
  }
  .syBtnTxtBrss{
  color: black;
  width: 44px;
  font-size:12px
}
 #home .van-notice-bar {
   border-radius: 10px;
   width: 315px;
 }
 .noticeBtn {
   /* position: relative;
   top: 100px;
   z-index: 3999; */

 }
</style>